import React, { Component } from "react";
import styled from "styled-components";
import "./App.css";
import Card from "./card";

class App extends Component {
  render() {
    return (
      <div className="App">
        <h1>GRID LAYOUT BY DESIGN CODE IO</h1>
        <h2>THIS WILL REPRESENT OUR CARD COMPONENTS</h2>
        <GridWrapper>
          {[...Array(9)].map((e, index) => (
            <Card key={index} index={index} />
          ))}
        </GridWrapper>
      </div>
    );
  }
}

export default App;

const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: 300px 300px 300px;
  place-content: center;
  gap: 20px
  height: 1000px;
  max-width: 1200px;
  margin: 0 auto;
  gap: 20px;
`;



// WEBPACK FOOTER //
// ./src/App.js